import { Card ,Row,Col,ButtonGroup,Button} from "react-bootstrap";
const IssueCard = (
    { issue_id,
      computer_id,
    title,
    description,
    priority,
    status,
    reason,
    issue,
    issued_date,
    IssuedPerson_Name,
    assignee_Name,
    editIssue,
    deleteIssue,
    onclick
  }) => {
    const RouteToComputer = () =>{
      onclick(computer_id)
    }
    const dateFormat = (date) =>{
      // for date
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const currentdate = new Date(date)
      const formatted = currentdate.getDate() + ' ' + months[currentdate.getMonth()] + ', ' + currentdate.getFullYear()
      //for Time
      const Time = new Date(date)
        var h = Time.getHours()
        var m = Time.getMinutes()
        var s = Time.getSeconds()
        var formattedTime = h + ':' + m + ':' + s
        var [hour, min] = formattedTime.split(':')
        var ampm = hour >= 12 ? 'PM' : 'AM'
        hour = hour % 12
        hour = hour !== 0 ? hour : 12
        var formattedClockInTime = hour + ':' + min + ' ' + ampm
      return formatted +" "+ formattedClockInTime
    }
    return (
        <Card className="cards issue-card">
        <Card.Header className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }} onClick={RouteToComputer}>
            <div className="issue-title">
            {title}
            </div>
            <div>
            {status === "Open" ? (
                            <div className="issue-status issue-open">{status}</div>
                        ) : status === "Inprogress" ? (
                          <div className="issue-status issue-progress">{status}</div>
                        ) : status === "Closed" ?(
                          <div className="issue-status issue-closed">{status}</div>
                        ):(<></>)
                        }
            </div>
            </Card.Header>
        <Card.Body>
              <Row>
                <Card.Text className="d-flex justify-content-between">
                <div>
                  <strong> Computer:  </strong> { issue.ComputerName} 
                  </div>
                </Card.Text>
              </Row>
              <Row>
                <div>
                <strong> Issued by:  </strong>{IssuedPerson_Name} 
                </div>
              </Row>
              <Row>
                <div>
                <strong> Assign to:  </strong>{assignee_Name}
                </div>
              </Row>
              <Row>
                <div>
                <strong> Reason:  </strong>{reason}
                </div>
              </Row>
                <Row className="justify-content-between">
                        <Col ><strong> Description:  </strong>{description} </Col>
                        
                        <Col className="order-last d-flex justify-content-end"  >
                            <ButtonGroup className="float-right">
                               <Button variant="outline-primary" size="sm" onClick={(e) => {
                                    e.preventDefault();
                                    editIssue(issue);
                                }}><i className="bi bi-pencil-fill"></i></Button>
                                      {/* <Button variant="outline-danger" size="sm" onClick={(e) => {
                                         e.preventDefault();
                                          deleteIssue(issue)
                                    }}><i className="bi bi-trash-fill"></i></Button> */}
                            </ButtonGroup>
                        </Col>
                    </Row>
                    <Row>
                    <Card.Text className="d-flex justify-content-between">
                    <div>
                      <strong> Issued date:  </strong> {dateFormat(issued_date)} 
                      </div>
                      <div>
                      <strong>Priority: </strong>
                      {priority}
                     </div>
                    </Card.Text>
              </Row>
        </Card.Body>
      </Card>
    )
}
export default IssueCard;